import { render, staticRenderFns } from "./ListOrder.vue?vue&type=template&id=558fd0be&scoped=true"
import script from "./ListOrder.vue?vue&type=script&lang=js"
export * from "./ListOrder.vue?vue&type=script&lang=js"
import style0 from "./ListOrder.vue?vue&type=style&index=0&id=558fd0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558fd0be",
  null
  
)

export default component.exports